(function (global, factory) {
  'use strict';

  var api = factory();
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }
  if (global && global.document) {
    global.StrugaStickyAtcCanary = api;
    api.install(global);
  }
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var ACTIVE_CLASS = 'struga-satc--active';
  var CANARY_ATTRIBUTE = 'data-struga-satc-canary';
  var CONTROLLER_KEY = '__strugaStickyAtcController';
  var MANAGER_KEY = '__strugaStickyAtcManager';
  var QUERY_KEY = 'struga_satc_canary';
  var SESSION_KEY = 'struga:sticky-atc:canary';
  var MOBILE_QUERY = '(max-width: 768px)';
  var BLOCKING_SELECTOR = [
    'sidebar-drawer.active',
    'modal-box.popup.active',
    '[aria-modal="true"].is-open',
    '.basicLightbox--visible'
  ].join(',');

  function storageGet(storage, key) {
    try {
      return storage && storage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function storageSet(storage, key, value) {
    try {
      if (storage) {
        storage.setItem(key, value);
      }
    } catch (error) {
      return;
    }
  }

  function storageRemove(storage, key) {
    try {
      if (storage) {
        storage.removeItem(key);
      }
    } catch (error) {
      return;
    }
  }

  function readCanaryGate(host) {
    var search = host.location && typeof host.location.search === 'string'
      ? host.location.search
      : '';
    var params;
    try {
      params = new URLSearchParams(search);
    } catch (error) {
      return false;
    }
    if (params.has(QUERY_KEY)) {
      var explicit = params.get(QUERY_KEY);
      if (explicit === '1') {
        storageSet(host.sessionStorage, SESSION_KEY, '1');
        return true;
      }
      if (explicit === '0') {
        storageRemove(host.sessionStorage, SESSION_KEY);
      }
      return false;
    }
    return storageGet(host.sessionStorage, SESSION_KEY) === '1';
  }

  function classContains(element, value) {
    return Boolean(
      element &&
      element.classList &&
      typeof element.classList.contains === 'function' &&
      element.classList.contains(value)
    );
  }

  function isBlocked(documentObject) {
    var body = documentObject.body;
    var root = documentObject.documentElement;
    if (
      classContains(body, 'sidebar-move') ||
      classContains(body, 'struga-cd-locked') ||
      classContains(body, 'struga-search-open') ||
      classContains(root, 'struga-cd-locked')
    ) {
      return true;
    }
    return Boolean(
      typeof documentObject.querySelector === 'function' &&
      documentObject.querySelector(BLOCKING_SELECTOR)
    );
  }

  function isAvailable(button, form) {
    if (!button || button.disabled || classContains(button, 'disabled')) {
      return false;
    }
    if (
      typeof button.getAttribute === 'function' &&
      button.getAttribute('aria-disabled') === 'true'
    ) {
      return false;
    }
    return !classContains(form, 'disabled-cart');
  }

  function nextStickyState(previous, snapshot) {
    var mobile = Boolean(snapshot.mobile);
    var markerVisible = (
      mobile &&
      snapshot.markerBottom > 0 &&
      snapshot.markerTop < snapshot.viewportHeight
    );
    var seen = Boolean(previous.seen || markerVisible);
    // The fixed holder occupies the viewport bottom. It may remain fixed only
    // while the product-page itself extends beyond that boundary; otherwise
    // even a one-pixel shortfall would cover content owned by the next section.
    // Holder height is intentionally not the boundary: every pixel of a
    // bottom-fixed holder is inside product-page iff sectionBottom is below
    // the viewport bottom.
    var sectionOwnsViewportBottom = snapshot.sectionBottom > snapshot.viewportHeight;
    var active = Boolean(
      mobile &&
      seen &&
      snapshot.markerBottom <= 0 &&
      sectionOwnsViewportBottom &&
      snapshot.available &&
      !snapshot.blocked
    );
    return { seen: seen, active: active };
  }

  function addMediaListener(media, callback) {
    if (media && typeof media.addEventListener === 'function') {
      media.addEventListener('change', callback);
      return function () {
        media.removeEventListener('change', callback);
      };
    }
    if (media && typeof media.addListener === 'function') {
      media.addListener(callback);
      return function () {
        media.removeListener(callback);
      };
    }
    return function () {};
  }

  function createController(options) {
    var host = options.host;
    var documentObject = host.document;
    var page = options.page;
    var form = options.form;
    var button = options.button;
    var holder = options.holder;
    var wrapper = options.wrapper;
    var registry = options.registry;
    var onActiveChange = options.onActiveChange || function () {};
    var media = host.matchMedia(MOBILE_QUERY);
    var state = { seen: false, active: false };
    var destroyed = false;
    var frame = null;
    var observer = null;
    var removeMediaListener = function () {};
    var requestFrame = typeof host.requestAnimationFrame === 'function'
      ? host.requestAnimationFrame.bind(host)
      : function (callback) { return host.setTimeout(callback, 0); };
    var cancelFrame = typeof host.cancelAnimationFrame === 'function'
      ? host.cancelAnimationFrame.bind(host)
      : function (id) { host.clearTimeout(id); };

    function setActive(active, height) {
      if (active) {
        wrapper.style.setProperty(
          '--struga-satc-placeholder-height',
          Math.ceil(Math.max(height, 44)) + 'px'
        );
        wrapper.classList.add(ACTIVE_CLASS);
      } else {
        wrapper.classList.remove(ACTIVE_CLASS);
        wrapper.style.removeProperty('--struga-satc-placeholder-height');
      }
      state.active = active;
      onActiveChange();
    }

    function evaluate() {
      if (destroyed) {
        return state;
      }
      var markerRect = wrapper.getBoundingClientRect();
      var sectionRect = page.getBoundingClientRect();
      var holderRect = holder.getBoundingClientRect();
      var next = nextStickyState(state, {
        mobile: media.matches,
        markerTop: markerRect.top,
        markerBottom: markerRect.bottom,
        sectionBottom: sectionRect.bottom,
        holderHeight: holderRect.height,
        viewportHeight: host.innerHeight,
        available: isAvailable(button, form),
        blocked: isBlocked(documentObject)
      });
      state.seen = next.seen;
      if (next.active !== state.active) {
        setActive(next.active, holderRect.height);
      } else if (next.active) {
        wrapper.style.setProperty(
          '--struga-satc-placeholder-height',
          Math.ceil(Math.max(holderRect.height, 44)) + 'px'
        );
      }
      return { seen: state.seen, active: state.active };
    }

    function schedule() {
      if (destroyed || frame !== null) {
        return;
      }
      frame = requestFrame(function () {
        frame = null;
        evaluate();
      });
    }

    function destroy() {
      if (destroyed) {
        return;
      }
      destroyed = true;
      if (frame !== null) {
        cancelFrame(frame);
        frame = null;
      }
      host.removeEventListener('scroll', schedule);
      host.removeEventListener('resize', schedule);
      host.removeEventListener('orientationchange', schedule);
      removeMediaListener();
      if (observer) {
        observer.disconnect();
      }
      setActive(false, 0);
      if (page[CONTROLLER_KEY] === controller) {
        delete page[CONTROLLER_KEY];
      }
      registry.delete(controller);
    }

    var controller = {
      destroy: destroy,
      evaluate: evaluate,
      schedule: schedule,
      getState: function () {
        return { seen: state.seen, active: state.active };
      },
      nodes: {
        page: page,
        form: form,
        button: button,
        holder: holder,
        wrapper: wrapper
      }
    };

    host.addEventListener('scroll', schedule, { passive: true });
    host.addEventListener('resize', schedule);
    host.addEventListener('orientationchange', schedule);
    removeMediaListener = addMediaListener(media, schedule);
    if (typeof host.MutationObserver === 'function') {
      observer = new host.MutationObserver(schedule);
      observer.observe(button, {
        attributes: true,
        attributeFilter: ['class', 'disabled', 'aria-disabled']
      });
      observer.observe(form, {
        attributes: true,
        attributeFilter: ['class']
      });
      if (documentObject.body) {
        observer.observe(documentObject.body, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: [
            'class',
            'disabled',
            'aria-disabled',
            'aria-modal'
          ]
        });
      }
      if (documentObject.documentElement) {
        observer.observe(documentObject.documentElement, {
          attributes: true,
          attributeFilter: ['class']
        });
      }
    }
    registry.add(controller);
    page[CONTROLLER_KEY] = controller;
    evaluate();
    return controller;
  }

  function attachPage(page, host, registry, onActiveChange) {
    if (!page || page[CONTROLLER_KEY]) {
      return page ? page[CONTROLLER_KEY] : null;
    }
    var form = page.querySelector(
      'product-form form[data-type="add-to-cart-form"]'
    );
    if (!form) {
      return null;
    }
    var button = form.querySelector(
      'button[name="add"][data-js-product-add-to-cart]'
    );
    if (!button || typeof button.closest !== 'function') {
      return null;
    }
    var holder = button.closest('.buttons-holder');
    var wrapper = button.closest('.buttons-holder-fix');
    if (!holder || !wrapper || (typeof page.contains === 'function' && !page.contains(wrapper))) {
      return null;
    }
    return createController({
      host: host,
      page: page,
      form: form,
      button: button,
      holder: holder,
      wrapper: wrapper,
      registry: registry,
      onActiveChange: onActiveChange
    });
  }

  function pagesWithin(root) {
    var pages = [];
    if (root && typeof root.matches === 'function' && root.matches('product-page')) {
      pages.push(root);
    }
    if (root && typeof root.querySelectorAll === 'function') {
      Array.prototype.forEach.call(
        root.querySelectorAll('product-page'),
        function (page) {
          if (pages.indexOf(page) === -1) {
            pages.push(page);
          }
        }
      );
    }
    return pages;
  }

  function install(host) {
    if (host[MANAGER_KEY]) {
      return host[MANAGER_KEY];
    }
    var documentObject = host.document;
    var registry = new Set();
    var enabled = readCanaryGate(host);
    function syncRootActive() {
      var anyActive = Array.from(registry).some(function (controller) {
        return controller.getState().active;
      });
      documentObject.documentElement.classList.toggle(
        'struga-satc-active-root',
        anyActive
      );
    }
    var manager = {
      enabled: enabled,
      controllers: registry,
      attachWithin: function (root) {
        if (!enabled) {
          return [];
        }
        return pagesWithin(root).map(function (page) {
          return attachPage(page, host, registry, syncRootActive);
        }).filter(Boolean);
      },
      destroy: function () {
        Array.from(registry).forEach(function (controller) {
          controller.destroy();
        });
        documentObject.removeEventListener('shopify:section:load', onSectionLoad);
        documentObject.removeEventListener('shopify:section:unload', onSectionUnload);
        documentObject.documentElement.removeAttribute(CANARY_ATTRIBUTE);
        documentObject.documentElement.classList.remove('struga-satc-active-root');
        delete host[MANAGER_KEY];
      }
    };

    function onSectionLoad(event) {
      manager.attachWithin(event.target);
    }

    function onSectionUnload(event) {
      Array.from(registry).forEach(function (controller) {
        var page = controller.nodes.page;
        if (
          page === event.target ||
          (
            event.target &&
            typeof event.target.contains === 'function' &&
            event.target.contains(page)
          )
        ) {
          controller.destroy();
        }
      });
    }

    host[MANAGER_KEY] = manager;
    if (!enabled) {
      return manager;
    }
    documentObject.documentElement.setAttribute(CANARY_ATTRIBUTE, '1');
    documentObject.addEventListener('shopify:section:load', onSectionLoad);
    documentObject.addEventListener('shopify:section:unload', onSectionUnload);
    if (documentObject.readyState === 'loading') {
      documentObject.addEventListener(
        'DOMContentLoaded',
        function () { manager.attachWithin(documentObject); },
        { once: true }
      );
    } else {
      manager.attachWithin(documentObject);
    }
    return manager;
  }

  return {
    ACTIVE_CLASS: ACTIVE_CLASS,
    BLOCKING_SELECTOR: BLOCKING_SELECTOR,
    MOBILE_QUERY: MOBILE_QUERY,
    QUERY_KEY: QUERY_KEY,
    SESSION_KEY: SESSION_KEY,
    attachPage: attachPage,
    createController: createController,
    install: install,
    isAvailable: isAvailable,
    isBlocked: isBlocked,
    nextStickyState: nextStickyState,
    readCanaryGate: readCanaryGate
  };
});
